import { render, staticRenderFns } from "./Cupom.vue?vue&type=template&id=016ff797&scoped=true"
import script from "./Cupom.vue?vue&type=script&lang=js"
export * from "./Cupom.vue?vue&type=script&lang=js"
import style0 from "./Cupom.vue?vue&type=style&index=0&id=016ff797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ff797",
  null
  
)

export default component.exports